module.exports = __webpack_public_path__ + "img/tzzh_zhCn.ed3ce223.png";